import { useHashScroll } from "./hooks/useHashScroll";

export const HashScroller = (): null => {
  useHashScroll();
  return null;
};
